import { email } from './email';
import { password } from './password';

export const Schemas = {
  email,
  password,
};
